import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { useContext, useEffect } from 'react';
import { AdContext } from './AdContext';
import { AdProviders, ADUNIT_PROVIDER_SAFETY_KEY, FREESTAR_PREFIX } from './constants';
import { isSSR } from './utils';
import { BiContext } from '@wix/da-bi/pkg/BiLogger.context';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
export function useAdUnit(provider, unitId, safety, options) {
    const { DaAds  } = useContext(AdContext);
    const { abTests , adsPxl , ppId  } = useContext(SessionContext);
    const isNsfgFallback = useFlag('ads_dealer_nsfg');
    const isPxl = useFlag('ads_pxl');
    // TODO if freestar is perma give them their own ID set
    if (provider === AdProviders.Freestar) {
        unitId = `${FREESTAR_PREFIX}${unitId}`;
    }
    // Pixelate - off on dev
    let pixelateOn = (adsPxl === null || adsPxl === void 0 ? void 0 : adsPxl.enabled) ? 'on' : 'off';
    if (process.env.NODE_ENV !== 'production' || process.env.XHR_ENV === 'vm') {
        pixelateOn = 'off';
    }
    // Pixelate - whitelisted units
    const unitMatches = [
        /anchor/
    ];
    unitMatches.forEach(function(m) {
        if (m.test(unitId)) {
            pixelateOn = 'off';
        }
    });
    let pxl = {};
    if (isPxl) {
        var _adsPxl_sample;
        pxl = {
            pxon: pixelateOn,
            pxsample: (_adsPxl_sample = adsPxl === null || adsPxl === void 0 ? void 0 : adsPxl.sample) !== null && _adsPxl_sample !== void 0 ? _adsPxl_sample : '100000000',
            pdid: ppId,
            pip: adsPxl === null || adsPxl === void 0 ? void 0 : adsPxl.pip,
            pua: adsPxl === null || adsPxl === void 0 ? void 0 : adsPxl.pua
        };
    }
    var _options_targeting;
    // Add default targeting data, allow consumer to override
    options.targeting = _object_spread({
        ab: abTests
    }, pxl, (_options_targeting = options.targeting) !== null && _options_targeting !== void 0 ? _options_targeting : {});
    // Add safety to the options
    options[ADUNIT_PROVIDER_SAFETY_KEY[provider]] = safety;
    // In ssr we register on render
    if (isSSR()) {
        DaAds === null || DaAds === void 0 ? void 0 : DaAds.registerUnit(provider, unitId, safety, options);
    }
    const biContext = useContext(BiContext);
    const publicSession = useContext(SessionContext);
    // On client we have side effect + kill on unmount
    useEffect(()=>{
        if (!isSSR()) {
            DaAds === null || DaAds === void 0 ? void 0 : DaAds.registerUnit(provider, unitId, safety, options);
        }
        return ()=>{
            DaAds === null || DaAds === void 0 ? void 0 : DaAds.killUnit(unitId, safety);
        };
    // only run on safety change, DaAds will handle recreation
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        safety
    ]);
    // sync bi data
    useEffect(()=>{
        if (!isSSR()) {
            DaAds === null || DaAds === void 0 ? void 0 : DaAds.setBiContext(biContext, publicSession);
        }
    }, [
        DaAds,
        biContext,
        publicSession
    ]);
    return {
        // suppress + danger is hack that forces current react (16+)
        // to NOT clear the inner element on hydration, this stops
        // the clobbering of the adunit on first client render.
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: ''
        },
        id: unitId,
        'data-canfs': 'yes',
        'data-safety': safety,
        advertIsOff: safety === 'off' ? isNsfgFallback ? 'fallback' : 'off' : false
    };
}
